import type { CollectionPage } from "schema-dts";

import { getBlogUrl } from "../../../src/getUrls";

export type GetCategoriesPageJsonLdParams = {
  locale: string;
};

export function getCategoriesPageJsonLd({
  locale,
}: GetCategoriesPageJsonLdParams): CollectionPage {
  return {
    "@type": "CollectionPage",
    "@id": `${getBlogUrl({ locale })}/categories`,
    url: `${getBlogUrl({ locale })}/categories`,
  };
}
